export { MainTabView } from './tab-view';
